import React, { useMemo, useState } from "react";
import { Section } from "../ui/Section";
import { Field } from "../ui/Field";
import { MultiSelectChips } from "../ui/MultiSelectChips";
import styles from "../../styles/evento-form.module.css";
import { isDateInRange, fmtLongDate } from "../../domain/eventoUtils";

export function StepMenus({
    form,
    setForm,
    setNotice,

    // acciones form
    addItem,
    removeItem,
    updateArray,

    // accordion
    isMenuOpen,
    toggleMenu,
    setOpenMenus,

    // catálogos
    platosById,
    platoOptions,
    vinoOptions,

    // datos derivados
    totalParticipantesEvento,

    // constantes
    POS_LABELS = ["Primer plato", "Segundo plato", "Postre"],
}) {
    const [dragPlato, setDragPlato] = useState(null);

    const habitacionSafe = useMemo(() => form, [form]);
    const reorderOptionsSelectedFirst = (options, selectedIds) => {
        const selectedSet = new Set((selectedIds || []).map(String));

        const selectedInOrder = (selectedIds || [])
            .map((id) => options.find((o) => String(o.value) === String(id)))
            .filter(Boolean);

        const rest = (options || [])
            .filter((o) => !selectedSet.has(String(o.value)))
            .sort((a, b) => (a.label || "").localeCompare(b.label || "", "es"));

        return [...selectedInOrder, ...rest];
    };


    return (
        <Section title="Menús & Vinos">
            <Section
                title="Menús"
                aside={
                    <div className={styles["actions-row"]}>
                        <button
                            className={`${styles.btn} ${styles.primary}`}
                            type="button"
                            onClick={() => {
                                addItem("menus", {
                                    nombre: "",
                                    fecha: "",
                                    lugar: "",
                                    comensales: totalParticipantesEvento,
                                    platoIds: [],
                                    vinoIds: [],
                                });
                                const newIdx = form.menus.length;
                                setOpenMenus((s) => new Set([...s, newIdx]));
                            }}
                        >
                            + Añadir
                        </button>
                    </div>
                }
            >
                {form.menus.map((m, i) => {
                    const open = isMenuOpen(i);
                    const nombre = `${m.nombre || "Sin nombre"}`;
                    const resumen = `${fmtLongDate(m.fecha) || "Sin fecha"} • ${m.lugar || "Sin lugar"} • ${m.comensales || "Sin comensales"
                        }`;

                    return (
                        <div
                            key={`menu-${i}`}
                            className={`${styles["item-card"]} ${styles.accordion} ${open ? styles.open : ""}`}
                        >
                            <button
                                type="button"
                                className={styles["accordion-header"]}
                                onClick={() => toggleMenu(i)}
                                aria-expanded={open}
                                aria-controls={`menu-body-${i}`}
                            >
                                <div className={styles["accordion-title"]}>
                                    <strong>{nombre}</strong>
                                    <span className={styles.muted}>— {resumen}</span>
                                </div>
                                <span className={styles.chevron} aria-hidden>
                                    ▾
                                </span>
                            </button>

                            <div id={`menu-body-${i}`} className={styles["accordion-body"]}>
                                <div className={styles["item-row"]}>
                                    <div className={styles["grid-4"]}>
                                        <Field label="Nombre del menú">
                                            <input
                                                type="text"
                                                className={styles["big-input"]}
                                                value={m.nombre}
                                                onChange={(e) => updateArray("menus", i, "nombre", e.target.value)}
                                            />
                                        </Field>

                                        <Field label="Fecha del menú">
                                            <input
                                                type="date"
                                                className={styles["big-input"]}
                                                value={m.fecha || ""}
                                                min={form.fechaInicio || undefined}
                                                max={form.fechaFin || undefined}
                                                onChange={(e) => {
                                                    const val = e.target.value;
                                                    if (!isDateInRange(val, form.fechaInicio, form.fechaFin)) {
                                                        setNotice(
                                                            "La fecha del menú debe estar entre la fecha de inicio y fin del evento."
                                                        );
                                                        return;
                                                    }
                                                    setNotice("");
                                                    updateArray("menus", i, "fecha", e.target.value);
                                                }}
                                            />
                                        </Field>

                                        <Field label="Lugar del menú">
                                            <input
                                                type="text"
                                                className={styles["big-input"]}
                                                value={m.lugar}
                                                onChange={(e) => updateArray("menus", i, "lugar", e.target.value)}
                                            />
                                        </Field>

                                        <Field label="Nº de comensales">
                                            <input
                                                type="number"
                                                min={0}
                                                value={
                                                    m.comensales != null && m.comensales !== ""
                                                        ? m.comensales
                                                        : totalParticipantesEvento
                                                }
                                                onChange={(e) =>
                                                    updateArray(
                                                        "menus",
                                                        i,
                                                        "comensales",
                                                        e.target.value === "" ? "" : Number(e.target.value)
                                                    )
                                                }
                                            />
                                        </Field>
                                    </div>

                                    {/* Platos (2 columnas) */}
                                    <div className={styles["grid-2"]} style={{ marginTop: 40 }}>
                                        {/* Izquierda: orden */}
                                        <div>
                                            <Field label="Orden del menú">
                                                <div className={styles.posiciones}>
                                                    {POS_LABELS.map((label, idx) => {
                                                        const platoId = m.platoIds[idx];
                                                        const plato = platosById.get(String(platoId));

                                                        return (
                                                            <div
                                                                key={label}
                                                                className={styles.posRow}
                                                                style={{
                                                                    display: "grid",
                                                                    gridTemplateColumns: "140px 1fr",
                                                                    gap: 8,
                                                                    marginBottom: 6,
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                <div className={styles.posLabel}>
                                                                    <strong>{label}</strong>
                                                                </div>

                                                                <div className={styles.posValue}>
                                                                    {plato ? (
                                                                        <span
                                                                            className={`${styles.chip} ${styles["chip-draggable"]}`}
                                                                            draggable
                                                                            onDragStart={() => setDragPlato({ menuIndex: i, from: idx })}
                                                                            onDragOver={(e) => e.preventDefault()}
                                                                            onDrop={() => {
                                                                                if (!dragPlato || dragPlato.menuIndex !== i) return;
                                                                                const from = dragPlato.from;
                                                                                const to = idx;
                                                                                if (from === to) return;

                                                                                setForm((prev) => {
                                                                                    const menus = [...prev.menus];
                                                                                    const current = menus[i];
                                                                                    const platoIds = Array.isArray(current.platoIds)
                                                                                        ? [...current.platoIds]
                                                                                        : [];

                                                                                    if (
                                                                                        from < 0 ||
                                                                                        from >= platoIds.length ||
                                                                                        to < 0 ||
                                                                                        to >= platoIds.length
                                                                                    ) {
                                                                                        return prev;
                                                                                    }

                                                                                    const [moved] = platoIds.splice(from, 1);
                                                                                    platoIds.splice(to, 0, moved);

                                                                                    menus[i] = { ...current, platoIds };
                                                                                    return { ...prev, menus };
                                                                                });

                                                                                setDragPlato(null);
                                                                            }}
                                                                            title="Arrastra para cambiar el orden"
                                                                        >
                                                                            {plato.nombre}
                                                                        </span>
                                                                    ) : (
                                                                        <span className={styles.muted}>— Sin plato asignado —</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </Field>
                                        </div>

                                        {/* Derecha: selector */}
                                        <div>
                                            <Field
                                                label="Platos del menú"
                                                hint="Busca y marca varios; el orden se cambia arrastrando los platos en la columna izquierda."
                                            >
                                                <MultiSelectChips
                                                    options={reorderOptionsSelectedFirst(platoOptions || [], m.platoIds || [])}
                                                    value={m.platoIds}
                                                    onChange={(vals) => updateArray("menus", i, "platoIds", vals)}
                                                    hideSelected={true}
                                                />
                                            </Field>
                                        </div>
                                    </div>



                                    <Field label="Vinos del menú">
                                        <MultiSelectChips
                                            options={vinoOptions}
                                            value={m.vinoIds || []}
                                            onChange={(vals) => updateArray("menus", i, "vinoIds", vals)}
                                            placeholder="Buscar vinos..."
                                            hideSelected={false}
                                        />
                                    </Field>
                                </div>
                                <div className={styles["item-actions"]}>
                                    <button
                                        className={`${styles.btn} ${styles.danger}`}
                                        type="button"
                                        onClick={() => removeItem("menus", i)}
                                    >
                                        Eliminar menú
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })}

                <div className={styles.hint}>
                    Los menús se asignan automáticamente a todos los participantes.
                </div>
            </Section>
        </Section>
    );
}
